export const GOOGLE_REVIEW_RATING = "5.0";
export const GOOGLE_REVIEW_PROOF_LABEL =
  "Public Google reviews across Singing Attitude profiles";
export const GOOGLE_REVIEW_PUBLIC_LABEL = "Public Google reviews";
export const GOOGLE_REVIEW_BASED_ON_LABEL = "Based on public Google reviews";
